import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CoreService, ErrorService } from '../services';
import { QueovalBase, eAppContext, Alert, AlertCode } from '../models';
import { BaseInterceptor, eHeadersMode } from './base.interceptor';
import { ToastService } from '../toast';

@Injectable()

/*
 *  intercepts http responses from the api to check if there were any errors
 *  if there is a 401 Unauthorized response the user is automatically logged out of the application,
 *  all other errors are re-thrown up to the calling service so an alert can be displayed to the user.
 *
 *  It's implemented using the HttpInterceptor class that was introduced in Angular 4.3 as part of the new HttpClientModule.
 *  By extending the HttpInterceptor class you can create a custom interceptor to catch all error responses from the server in a single location.
 *  Http interceptors are added to the request pipeline in the providers section of the app.module.ts file.
*/
export class ErrorInterceptor extends BaseInterceptor implements HttpInterceptor {
  //private css: string = 'font-size: 40px; font-weight: bold; color: #FF0000; padding:30px;';

  constructor(
    protected router: Router,
    protected indParam: CoreService,
    private exception: ErrorService,
    private toast: ToastService,
  ) { super(indParam); }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headerMode: string = this.setUrlMode(request.url);
    return next.handle(request).pipe(
      tap((ev: HttpEvent<any>) => {
        if (ev instanceof HttpResponse) {
          // uploading process result (it is not working on production "maybe")
          //if (headerMode === eHeadersMode.UPLOAD && ev.statusText.toLowerCase() === 'created' && ev.status === 201) {
          //const fn: string | null = ev.headers.get('httpPath');
          //if (fn) { localStorage.setItem('httpPath', fn); }
          //const ft: string | null = ev.headers.get('fileName');
          //if (ft) { localStorage.setItem('fileName', ft); }
          //}
          if (request.url.toLowerCase().indexOf('api/notification') === -1) {
            this.setErrorMNG(ev.body as QueovalBase, request.url, request.body);

            if (headerMode === eHeadersMode.DEFAULT || eHeadersMode.FORMDATA) {
              this.setAlertMNG(ev.body as QueovalBase);
            }
          }
        }
      }),
      catchError((error: any) => {

        if (request.url.toLowerCase().indexOf('api/notification') === -1) {
          if (error && error.status && error.status === 401)
            this.setErrorAUT(error);
          else
            this.setErrorUNM(error, request.url, request.body);
        }

        return observableThrowError(error);
      })) as any;
  }

  private setErrorAUT(error: any): void {
    console.error('%c UNAUTHENTICATED REQUEST'); //, this.css);
    console.error(JSON.stringify(error));
    // this.auth.logout();
    switch (this.indParam.Context) {
      case eAppContext.QUEOVAL:
      case eAppContext.EXTRANET:
        if (document && document.location) {
          document.location.href = `${this.indParam.AppParams.appUrl}PageConnection.aspx`;
        }
        break;
      case eAppContext.ELEARNING:
      case eAppContext.QUESTIONNAIRE:
        this.router.navigateByUrl('/login');
        break;
      case eAppContext.WEBSTORE:

        break;
    }
  }

  private setErrorUNM(error: any, requestUrl: string, body: any): void {
    console.error('%c UNMANAGED ERROR') //, this.css);
    console.error(JSON.stringify(error));
    console.error(requestUrl);

    this.exception.setGenericError(error, requestUrl, body);
    this.openError();
  }

  private setErrorMNG(model: QueovalBase, requestUrl: string, body: any): void {
    if (model != null && model.HasError) {
      this.indParam.showSplash(false);
      if (this.redirectError(model.Error, requestUrl)) {
        this.exception.setQueovalError(model.Error, requestUrl, body);
        this.openError();
      }
    }
  }

  private setAlertMNG(model: QueovalBase): void {
    if (model != null && model.CodedAlerts != null && model.CodedAlerts.length > 0) {

      for (let i: number = 0; i < model.CodedAlerts.length; i++) {
        const alert: Alert = model.CodedAlerts[i];

        ////////if (model.CodedAlerts.filter((a: Alert) => a.Message === alert.Message).length > 1) {
        ////////  model.CodedAlerts.splice(i, 1);
        ////////  i--;
        ////////}

        // Traduire les quelques codes qui ne peuvent pas être traduits dans le back car pas d'accès au indParam
        switch (alert.Message) {
          case 'noUser':
            alert.Message = this.indParam.getTrad('noUser'); break;
          case 'wrongPassword':
            alert.Message = this.indParam.getTrad('wrongPassword'); break;
        }

        if (alert.Message.length > 0) {
          switch (alert.Code) {
            case AlertCode.ALERT:
              this.toast.showWarningToast(alert.Message, alert.Message.length  < 100 ? 10000 : alert.Message.length * 100);
              break;
            case AlertCode.BLOCKING_ERROR:
              this.toast.showAlertToast(alert.Message, alert.Message.length < 100 ? 10000 : alert.Message.length * 100);
              model.HasError = true;
              break;
            case AlertCode.ERROR:
              this.toast.showAlertToast(alert.Message, alert.Message.length  < 100 ? 10000 : alert.Message.length  * 100);
              break;
            case AlertCode.INFO:
              this.toast.showInfoToast(alert.Message, alert.Message.length  < 30 ? 3000 : alert.Message.length * 100);
              break;
            case AlertCode.SUCCESS:
              this.toast.showSuccessToast(alert.Message, alert.Message.length < 30 ? 3000 : alert.Message.length * 100);
              break;
          }
        }
      }

      model.CodedAlerts = [];
    }
  }

  private openError(): void {
    this.router.navigate(['view/error']);
    // suppression manuelle des backgrounds des modales encore ouvertes
    let lstModales: any = document.getElementsByClassName('modal-backdrop');
    for (let item of lstModales) {
      item.remove();
    }
  }

  private redirectError(error: string, url: string): boolean {
    const rd: boolean = url.toLowerCase().indexOf(('api/googleMails/getData/MAININIT').toLowerCase()) > -1 && error.toLowerCase().indexOf(('Invalid Google Auth').toLowerCase()) > -1;
    return !rd;
  }
}
